import { QueryOperation, SearchQuery } from "../code/search-query/search-query";
import {
  buildSearchQuery,
  dateValue,
  QueryFieldMapping,
} from "../code/search-query/query-mapper";
import { DataColumn } from "../controls/Data.default";
import { DynamicSchema } from "../controls/DynamicForm.default";

export interface CollaboratorsViewForm {
  readonly email: string;
  readonly phoneNumber: string;
  readonly firstName: string;
  readonly lastName: string;
  readonly dateOfBirth: string;
}

export const collaboratorsViewColumns: DataColumn[] = [
  {
    title: "User Name",
    key: "userName",
    width: 192,
    sort: true,
    defaultSort: "asc",
  },
  {
    title: "First Name",
    key: "firstName",
    width: 192,
    sort: true,
  },
  {
    title: "Last Name",
    key: "lastName",
    width: 192,
    sort: true,
  },
  {
    title: "Middle Name",
    key: "middleName",
    width: 192,
    sort: true,
  },
  {
    title: "Date Of Birth",
    key: "dateOfBirth",
    width: 192,
    format: "DD/MM/YYYY",
    sort: true,
  },
  {
    title: "Email",
    key: "email",
    width: 192,
    sort: true,
  },
  {
    title: "Email Confirmed",
    key: "emailConfirmed",
    width: 128,
    sort: true,
  },
  {
    title: "Phone Number",
    key: "phoneNumber",
    width: 192,
    sort: true,
  },
  {
    title: "Phone Number Confirmed",
    key: "phoneNumberConfirmed",
    width: 192,
    sort: true,
  },
  {
    title: "Assigned Companies",
    key: "assignedCompaniesCount",
    width: 192,
    sort: false,
    type: "badge",
  },
];

const collaboratorsQueryMappings: QueryFieldMapping[] = [
  { formField: "email" },
  { formField: "phoneNumber" },
  { formField: "firstName" },
  { formField: "lastName" },
  { formField: "dateOfBirth", operation: QueryOperation.Equal, transform: dateValue },
];

export const mapCollaboratorsViewQuery = (values: CollaboratorsViewForm): SearchQuery =>
  buildSearchQuery(values, collaboratorsQueryMappings);

export const collaboratorsSearchSchema: DynamicSchema = {
  groups: [
    {
      controls: [
        { type: "textbox", name: "email", label: "Email" },
        { type: "textbox", name: "phoneNumber", label: "Phone Number" },
        { type: "textbox", name: "firstName", label: "First Name" },
        { type: "textbox", name: "lastName", label: "Last Name" },
        { type: "datepicker", name: "dateOfBirth", label: "Date Of Birth" },
      ],
    },
  ],
};
